/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Tool_Enablement_Reset_DescInputs */



/**
* | output |
* | --- |
* | "A tool's enablement override was removed, so the default posture applies again." |
*
* @param {Audit_Details_Tool_Enablement_Reset_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_tool_enablement_reset_desc = /** @type {((inputs?: Audit_Details_Tool_Enablement_Reset_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Tool_Enablement_Reset_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Freigabe-Ausnahme eines Werkzeugs wurde entfernt, damit gilt wieder die Standardeinstellung.")
	return /** @type {LocalizedString} */ ("A tool's enablement override was removed, so the default posture applies again.")
});